const getFormattedMobile = (mobile: string) =>
  mobile.startsWith("+") ? mobile : `+91${mobile}`;

const getMsg91Window = () => window as any;

export const sendOtpUsingWidget = (mobile: string) =>
  new Promise((resolve, reject) => {
    const win = getMsg91Window();
    if (!win || typeof win.sendOtp !== "function") {
      return reject(new Error("sendOtp not available"));
    }

    try {
      win.sendOtp(
        getFormattedMobile(mobile),
        (response: any) => resolve(response),
        (error: any) => reject(error),
      );
    } catch (e) {
      reject(e);
    }
  });

export const verifyOtpUsingWidget = (otp: string) =>
  new Promise((resolve, reject) => {
    const win = getMsg91Window();
    if (!win || typeof win.verifyOtp !== "function") {
      return reject(new Error("verifyOtp not available"));
    }

    try {
      win.verifyOtp(
        otp,
        (response: any) => resolve(response),
        (error: any) => reject(error),
      );
    } catch (e) {
      reject(e);
    }
  });

export const resendOtpUsingWidget = (mobile?: string) =>
  new Promise((resolve, reject) => {
    const win = getMsg91Window();
    if (!win || typeof win.retryOtp !== "function") {
      return reject(new Error("retryOtp not available"));
    }

    try {
      win.retryOtp(
        mobile ?? null,
        (response: any) => resolve(response),
        (error: any) => reject(error),
      );
    } catch (e) {
      reject(e);
    }
  });
